import type { AddressCoordinates } from './entities'
import type { AddressSearchSourceValues } from '@/tools/analytics/events/domains/address-book'

export type Step =
  | 'WHERE_TO_DELIVER'
  | 'FIND_ADDRESS_ON_MAP'
  | 'FIND_ADDRESS_BY_TEXT'
  | 'ADDRESS_TYPE_FORM'
  | 'ADDRESS_DETAILS_FORM'
  | 'SET_ENTRANCE'

export type StepActionType =
  | 'onCreateNewAddress'
  | 'onCreateAddressFromCurrentLocation'
  | 'onEditAddress'
  | 'onEditAddressWithoutDetails'
  | 'onMapInteraction'
  | 'useSearchInstead'
  | 'useMapInstead'
  | 'onLocationSelected'
  | 'onLocationIsOutOfZone'
  | 'onBack'
  | 'onNext'
  | 'onEditAddressLine'
  | 'onSetEntrance'
  | 'onBackToAddressList'
  | 'onBackToFindByText'

export type FloatingButtonVariant = 'CLOSE' | 'BACK'

export interface BrowserLocation {
  coordinates: AddressCoordinates | null
  geolocationPermission?: GeolocationPermissionType
}

export type GoogleCoordinates = google.maps.LatLngLiteral

// TODO: Delete once AddressBook is no longer consumed from iframe
export type SetLocationMessage = MessageEvent<{
  type: 'ADDRESS_BOOK.SET_LOCATION'
  payload: GeolocationCoordinates | null
}>
export type EntrySourceMessage = MessageEvent<{
  type: 'ADDRESS_BOOK.ENTRY_SOURCE'
  payload: AddressSearchSourceValues
}>

export enum GeolocationPermission {
  PROMPT = 'prompt',
  GRANTED = 'granted',
  DENIED = 'denied',
  UNSUPPORTED = 'unsupported',
}

export type GeolocationPermissionType = `${GeolocationPermission}`
